import BaseModel from '../core/BaseModel'
export default class HistoryEvaluationModel extends BaseModel {
    constructor() {
        super({
            tableName: 'history_evaluation', label: "Lịch sử đánh giá", display_key: 'name',name: "history_evaluation",
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              class: 'center width_150 common',
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID', 
              primaryKey: true,  
              display: false
            },
            evaluation_from_name: { 
              name: 'evaluation_from_name', 
              type: "TEXT", 
              label: 'Phiếu đánh giá',
              filter: { type: "input", match: "contains" },
            },
            situation_name: { 
              name: 'situation_name', 
              type: "TEXT", 
              label: 'Tình huống',
              filter: { type: "input", match: "contains" },
            },
            type : {
              name: 'type', 
              type: "Selection", 
              label: 'Phân loại',
              class: '',
              width: 5,
              options: [
                {value : "PERIODIC" , label : "Định kỳ"},
                {value : "ABMORMAL" , label : "Bất thường"},
                {value : "FREQUENT" , label : "Thường xuyên"},
              ],
              filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            category: {
              name: "category",
              label: "Nhóm mối nguy",
              type: "MultiSelect",
              width: 11,
              filter: {
                type: "SelectScroll",
                optionLabel: "name",
                optionKey: "id",
                match: "equals",
              },
            },
            // category_id: {
            //   name: 'category_id',
            //   label: 'Nhóm mối nguy',
            //   type: "Selection",
            //   custom: "SelectionText",
            //   filter: {
            //       type: "SelectScroll",
            //       optionLabel: "name",
            //       optionKey: "id",
            //       match: "equals",
            //   },
            // },
            danger_name: { 
              name: 'danger_name', 
              type: "TEXT", 
              label: 'Mối nguy',
              filter: { type: "input", match: "contains" },
            },
            point: { 
              name: 'point', 
              type: "CustomPopup", 
              label: 'R', 
            },
            code: { 
              name: 'code', 
              type: "TEXT", 
              label: 'Mức độ', 
            },
            criteria_level_description: { 
              name: 'criteria_level_description', 
              type: "TEXT", 
              label: 'Mô tả mức độ', 
            },
            status : {
              name: 'status', 
              type: "Selection", 
              // custom: 'SelectionText',
              label: 'Trạng thái',
              class: '',
              width: 5,
              options: [
                {label: "Mới",value: 'NEW'},
                {label: "Chờ review",value: 'REVIEW'},
                {label: "Chờ approve",value: 'WAITTING_APPROVED'},
                {label: "Đã approve",value: 'APPROVE'},
                {label: "Đã đóng",value: 'COMPLETE'}
              ],
              filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            updated_name: {
              renamefs:"updated_name",
              type: "String",
              label: "Người cập nhật"
            },
            created_at : {
              name: 'updated_at',
              type: "Datetime",
              label: 'Ngày cập nhật',
            },
        })
    }

}